module.exports = __webpack_public_path__ + "static/img/additional-reports.282de15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vilocal/additional-reports.png
// module id = 8Fpg
// module chunks = 2